import { useBlocksConfig } from "@pathwright/blocks-engine"
import { Content } from "@pathwright/ui/src/components/content/Content"
import { quillContentCSS } from "@pathwright/ui/src/components/quill/ui"
import renderMathInElement from "@pathwright/ui/src/components/text/katex-auto-render"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { interpolateVariables } from "../utils/variables"

export const BlockTextWrap = styled.div`
  ${quillContentCSS}

  overflow-y: hidden;
  /* Allow side-scrolling for elements like tables */
  overflow-x: auto;

  /* Disable side-scrolling for specific element types */
  & > p > strong {
    overflow-x: hidden;
  }

  @media screen and (min-width: 900px) {
    & > p.ql-align-center {
      // Solves scrollbar issues in some Windows browsers
      overflow: hidden;
    }
  }

  .code-block {
    padding: 16px;
    display: block;
    white-space: pre-wrap !important;

    & > code {
      padding: 0;
      /* line-height: 1.65; */
    }
  }
`

const BlockText = (props) => {
  const { html, text, templateContext: propsTemplateContext, style } = props

  const { templateVariables: configTemplateContext } = useBlocksConfig()

  const templateContext = propsTemplateContext || configTemplateContext

  const textRef = React.createRef()

  React.useEffect(() => {
    if (!textRef.current) return

    startKatex()
    setAriaAttributes()
  }, [textRef.current])

  const startKatex = () => {
    // const el = ReactDOM.findDOMNode(this)
    const el = textRef.current
    renderMathInElement(el, false)
    // responsifyKatex(el)
  }

  const setAriaAttributes = () => {
    const el = textRef.current
    const checkboxes = el.querySelectorAll("ul[data-checked] li")
    checkboxes.forEach((checkbox, index) => {
      checkbox.setAttribute("aria-checked", checkbox.parentElement.getAttribute("data-checked"))
      checkbox.setAttribute("role", "checkbox")
      checkbox.setAttribute("tabindex", "0")
    })
  }

  let content = html ? html : text || ""

  if (templateContext) {
    try {
      content = interpolateVariables(content, templateContext)
    } catch (error) {
      console.error("Error parsing template: ", error.toString())
    }
  }

  if (html) {
    return (
      <Content.Text>
        <BlockTextWrap
          ref={textRef}
          className="BlockText"
          dangerouslySetInnerHTML={{ __html: content }}
          style={style}
        />
      </Content.Text>
    )
  }

  return <div className="BlockText">{content}</div>
}

BlockText.propTypes = {
  html: PropTypes.string,
  text: PropTypes.string,
  templateContext: PropTypes.object,
  style: PropTypes.object
}

export default BlockText
